import axios from "axios";

export default function GuestShowService(id) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/guest/" + id,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
